import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-branding',
  template: `
    <div class="branding">
      <a href="/" class="branding-link">
        <div class="brand-icon">{{ brandInitial }}</div>
        <div class="brand-text">
          <span class="brand-name">{{ clientName }}</span>
          <span class="admin-portal-badge">Admin Portal</span>
        </div>
      </a>
    </div>
  `,
  styles: [`
    .branding {
      display: flex;
      align-items: center;
      padding: 0 8px;
    }
    
    .branding-link {
      display: flex;
      align-items: center;
      gap: 12px;
      text-decoration: none;
    }
    
    .brand-icon {
      width: 44px;
      height: 44px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      font-size: 1.75rem;
      font-weight: 700;
      flex-shrink: 0;
    }
    
    .brand-text {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }
    
    .brand-name {
      font-size: 1rem;
      font-weight: 700;
      color: #111827;
      letter-spacing: -0.3px;
      line-height: 1.3;
    }
    
    .admin-portal-badge {
      font-size: 0.6875rem;
      font-weight: 500;
      color: #6b7280;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      line-height: 1.2;
    }
    
    /* Dark mode support */
    @media (prefers-color-scheme: dark) {
      .brand-name {
        color: #f9fafb;
      }
      
      .admin-portal-badge {
        color: #9ca3af;
      }
    }
    
    /* Hover effect */
    .branding-link:hover .brand-icon {
      transform: scale(1.05);
      transition: transform 0.2s ease;
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
    }
  `]
})
export class BrandingComponent implements OnInit {
  clientName: string = '';  // Default fallback
  brandInitial: string = '';       // Default fallback

  constructor() {}

  ngOnInit(): void {
    this.loadClientName();
  }

  private loadClientName(): void {
    try {
      const cachedData = localStorage.getItem('tenantUI');
      
      if (cachedData) {
        const tenantUI = JSON.parse(cachedData);
        const branding = tenantUI?.data?.portalConfig?.branding;
        
        if (branding?.logo?.clientName) {
          this.clientName = branding.logo.clientName;
        }
      }
    } catch (error) {
      console.error('Error loading client name from tenantUI:', error);
      // Keep default fallback values
    }
    
    // Set brand initial (first letter of client name)
    this.brandInitial = this.clientName.charAt(0).toUpperCase();
  }
}